import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000";

const SetPaidDisbursementModal = ({ show, onHide, item, channels, onSuccess }) => {
  const [step, setStep] = useState(1);
  const [channelId, setChannelId] = useState("");
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (show) {
      setStep(1);
      setChannelId("");
      setFile(null);
    }
  }, [show, item]);

  const handleCopy = () => {
    if (item?.payroll_account) {
      navigator.clipboard.writeText(item.payroll_account);
      Swal.fire({ icon: "success", title: "Copied!", text: "No. rekening/akun disalin", timer: 1500 });
    }
  };

  const formatRupiah = (v) => {
    const n = parseFloat(v);
    if (isNaN(n)) return "Rp 0";
    return `Rp ${Math.floor(n).toLocaleString("id-ID")}`;
  };

  const handleSelesaiTransfer = async () => {
    setUploading(true);
    try {
      const token = localStorage.getItem("token");
      const formData = new FormData();
      if (file) formData.append("attachment", file);

      await axios.post(
        `${API_URL}/api/disbursements/${item.id}/paid`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      Swal.fire("Berhasil", "Pencairan berhasil ditandai selesai", "success");
      onSuccess?.();
      onHide();
    } catch (err) {
      Swal.fire("Gagal", err.response?.data?.error || "Terjadi kesalahan", "error");
    } finally {
      setUploading(false);
    }
  };

  if (!item) return null;

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {step === 1 && "Detail Pencairan"}
          {step === 2 && "Selesai Transfer"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {step === 1 && (
          <div>
            <p><strong>Officer:</strong> {item.full_name} ({item.position} - {item.division})</p>
            <p><strong>Payroll Type:</strong> {item.payroll_type || "-"}</p>
            <p className="d-flex align-items-center gap-2">
              <strong>Payroll Account:</strong>
              <code className="flex-grow-1">{item.payroll_account || "-"}</code>
              <Button variant="outline-secondary" size="sm" onClick={handleCopy}>
                Salin
              </Button>
            </p>
            <p><strong>Nominal:</strong> {formatRupiah(item.amount)}</p>
          </div>
        )}

        {step === 2 && (
          <Form.Group>
            <Form.Label>Upload Bukti Transfer</Form.Label>
            <Form.Control
              type="file"
              accept="image/*,application/pdf"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </Form.Group>
        )}


      </Modal.Body>
      <Modal.Footer>
        {step === 1 && (
          <Button variant="primary" onClick={() => setStep(2)}>Next</Button>
        )}
        {step === 2 && (
          <>
            <Button variant="secondary" onClick={() => setStep(1)}>Back</Button>
            <Button variant="success" onClick={handleSelesaiTransfer} disabled={uploading}>
              {uploading ? "Memproses..." : "Selesai Transfer"}
            </Button>
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default SetPaidDisbursementModal;
